module.exports = __webpack_public_path__ + "static/img/loading.02f9fbc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/gifs/loading.gif
// module id = GqUR
// module chunks = 1